import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useServicesSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionGroup: {
      marginBottom: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
    },
    serviceRow: {
      marginBottom: 0,
    },
    weekGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
      gap: theme.spacing(0.5),
      width: '100%',
    },
    dayCardGreen: {
      padding: theme.spacing(0.5),
      backgroundColor: '#e8f5e8',
    },
    dayCardGray: {
      padding: theme.spacing(0.5),
      backgroundColor: '#f5f5f5',
    },
    dayCardRed: {
      padding: theme.spacing(0.5),
      backgroundColor: '#ffebee',
    },
    serviceName: {
      fontSize: '0.75rem',
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    serviceTime: {
      fontSize: '0.875rem',
      color: '#666',
    },
    dayCard: {
      minWidth: 0,
      width: '100%',
    },
    serviceContent: {
      minHeight: '60px',
      width: '100%',
    },
    serviceNameContainer: {
      width: '100%',
    },
    strikethroughText: {
      textDecoration: 'line-through',
      opacity: 0.6,
      fontSize: '0.8rem',
      marginTop: theme.spacing(0.25),
      display: 'block',
    },
    specialEventTime: {
      fontWeight: 600,
    },
    highlightedCard: {
      position: 'relative',
      marginTop: theme.spacing(0.1),
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: '4px solid #ff3700',
        borderRadius: theme.shape.borderRadius,
        pointerEvents: 'none',
        animation: '$pulse 2s ease-in-out infinite',
      },
    },
    '@keyframes pulse': {
      '0%': {
        opacity: 1,
      },
      '50%': {
        opacity: 0.5,
      },
      '100%': {
        opacity: 1,
      },
    },
  }),
);
